<!-- 企业级-用户管理-临时用户 -->
<template>
  <div class="mainArea CCasualUser">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <div class="searchDiv">
          <div class="flex">
            <div class="mr10"><el-input placeholder="请输入姓名" v-model="keyword.user_name" @change="getUserList(1)" clearable></el-input></div>
            <div class="mr10"><el-input placeholder="请输入手机号码" v-model="keyword.phone_no" @change="getUserList(1)" clearable></el-input></div>
            <div><el-button type="primary" @click="getUserList(1)">搜索</el-button></div>
          </div>
        </div>
        <div class="tableList mt20">
          <el-table :data="casualData" style="width: 100%" v-loading="tableLoading">
            <el-table-column type="index" label="序号" width="100"></el-table-column>
            <el-table-column prop="user_name" sortable label="姓名"></el-table-column>
            <el-table-column prop="phone_no" sortable label="账号"></el-table-column>
            <el-table-column label="生物特征">
              <template slot-scope="scope">
                <el-button type="text" @click="openBios(scope.row.user_id)">查看</el-button>
              </template>
            </el-table-column>
            <el-table-column label="关联设备ID">
              <template slot-scope="scope">
                <el-button type="text" @click="openEquip(scope.row.user_id)">查看</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" sortable label="创建时间"></el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <el-button v-if="scope.row.user_state=='1'" type="text" @click="openStatus(scope.row.user_id,scope.row.user_state)">正常</el-button>
                <el-button v-else type="text" @click="openStatus(scope.row.user_id,scope.row.user_state)">禁用</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paging" v-if="pageCount>1">
          <el-pagination
            @current-change="CurrentChange"
            :current-page.sync="curr"
            @size-change="CurrentSizeChange"
            :page-sizes="[10,50,100,1000]"
            :page-size="page"
            layout="sizes,prev, pager, next, jumper"
            :page-count="pageCount">
          </el-pagination>
        </div>
      </div>
      <el-dialog title="生物特征" :visible.sync="biosDio" width="400" class="biosDio">
        <el-tabs v-model="tabNum" @tab-click="handleClick">
          <el-tab-pane label="指纹" name="1">
            <el-form ref="form" :model="form" label-width="60px">
              <el-form-item v-for="(fin,index) in form.finger" :key="index">
                <span slot="label">指纹{{index+1}}:</span>
                <div class="flex">
                  <el-input v-model="fin[index]"></el-input>
                  <i class="el-icon-circle-plus-outline fs25" v-if="index==0" @click="addFinger"></i>
                  <i class="el-icon-remove-outline fs25" v-else @click="delFinger(index)"></i>
                </div>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary">确认</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="人脸" name="2">
            <el-form ref="form2" :model="form2" label-width="60px">
              <el-form-item label="人脸:">
                <el-upload
                  :action="actionUrl"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="form.dialogImageUrl" alt="">
                </el-dialog>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary">确认</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="员工卡" name="3">
            <el-form ref="form3" :model="form3" label-width="80px">
              <el-form-item v-for="(men,index) in form3.menber" :key="index">
                <span slot="label">员工卡{{index+1}}:</span>
                <div class="flex">
                  <el-input v-model="men[index]"></el-input>
                  <i class="el-icon-circle-plus-outline fs25" v-if="index==0" @click="addMenber"></i>
                  <i class="el-icon-remove-outline fs25" v-else @click="delMenber(index)"></i>
                </div>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary">确认</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
      <el-dialog title="关联设备" :visible.sync="equipDio" width="50%" class="equipDio">
        <div class="dioCont">
          <el-table :data="equipData" style="width: 100%">
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="device_no_id" label="设备ID"></el-table-column>
            <el-table-column prop="device_name" label="设备名称"></el-table-column>
            <el-table-column prop="device_type" label="设备类型"></el-table-column>
            <el-table-column label="使用期限">
              <template slot-scope="scope">
                <span v-if="scope.row.use_timetype=='0'">永久</span>
                <span v-else>{{scope.row.start_usetime}}~{{scope.row.end_usetime}}</span>
              </template>
            </el-table-column>
            <el-table-column label="使用次数" width="80">
              <template slot-scope="scope">
                <span v-if="scope.row.use_count=='-1'">无限次</span>
                <span v-else>{{scope.row.use_count}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paging" v-if="eq_total>eq_page">
          <el-pagination
            @current-change="eqCurrentChange"
            :current-page.sync="eq_curr"
            :page-size="eq_page"
            layout="prev, pager, next, jumper"
            :total="eq_total">
          </el-pagination>
        </div>
      </el-dialog>
      <el-dialog title="" :visible.sync="statusDio" width="300" class="statusDio">
        <div class="statusCont">
          <div>当前状态为 <b v-if="statusInfo.status=='1'">正常</b><b v-else>禁用</b></div>
          <div>是否将状态改为 <b v-if="statusInfo.status=='0'">正常</b><b v-else>禁用</b>？</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="statusDio = false">取 消</el-button>
          <el-button type="primary" @click="changeStatus"><template v-if="statusInfo.status=='1'">禁用</template><template v-else>正常</template></el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast } from "../../../../static/js/utility/utility.js"
  import { userApi } from "../../../../static/js/api.js"

  export default {
    name: 'CCasualUser',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        keyword:{
          user_name:'',//姓名
          phone_no:'',//手机号
        },
        casualData:[],//临时用户列表数据
        tableLoading:false,

        //分页
        curr:1,//当前页
        page:10,//显示个数
        pageCount:0,//总数据

        biosDio:false,//生物特征弹窗
        tabNum:'1',//tab默认选中
        form:{
          finger:[''],
        },
        
        dialogVisible: false,
        actionUrl:'https://jsonplaceholder.typicode.com/posts/',
        form2:{
          dialogImageUrl: '',
        },
        form3:{
          menber:[''],
        },

        equipDio:false,//关联设备弹窗
        equipData:[],//关联的设备列表
        //设备分页
        eq_curr:1,//当前页
        eq_page:10,//显示个数
        eq_total:0,//总数据

        statusDio:false,//状态弹窗
        statusInfo:{
          user_id:'',
          status:'',
        },
      }
    },

    mounted(){
    },

    created: async function () {
      // let phoneNo = this.$route.query.phone_no;
      // this.keyword.phone_no = phoneNo;
      this.keyword = {...this.keyword, ...this.$route.query}
      this.getUserList()
    },
    methods: {
      //打开生物特征弹窗
      openBios(user_id){
        this.getUserBios(user_id)
        this.biosDio = true
      },
      //获取临时用户生物特征
      async getUserBios(user_id){
        let that = this;
        const dataObj = {
          'user_id':user_id,
        }
        const res = await userApi.getTempProfile(dataObj)
        if(res.meta.code == '200'){
          // console.log(res.data)
        }else{
          showToast(res.meta.message)
          // that.$message.error(res.meta.message)
        }
      },
      //打开关联设备弹窗
      openEquip(user_id){
        this.getEquipList(user_id)
        this.equipDio = true
      },
      //查看关联设备
      async getEquipList(user_id){
        let that = this;
        const dataObj = {
          'user_id':user_id,
        }
        const res = await userApi.getUserDevice(dataObj)
        if(res.meta.code == '200'){
          that.equipData = res.data
          that.equipDio = true
        }else{
          showToast(res.meta.message)
          // that.$message.error(res.meta.message)
        }
      },
      //修改状态
      async changeStatus(){
        let that = this;
        const dataObj = {
          'user_id':that.statusInfo.user_id,
        }
        const res = await userApi.changeTempStatus(dataObj)
        if(res.meta.code == '200'){
          that.getUserList()
          showToast('状态修改成功！')
          // that.$message.success('状态修改成功！')
          that.statusDio = false
        }else{
          showToast(res.meta.message)
          // that.$message.error(res.meta.message)
        }
      },
      //打开状态弹窗
      openStatus(user_id,status){
        this.statusInfo={
          user_id:user_id,
          status:status,
        }
        this.statusDio = true
      },
      //添加员工卡
      addMenber(){
        this.form3.menber.push('');
      },
      //删除员工卡
      delMenber(index){
        this.form3.menber.splice(index,1);
      },
      //添加指纹
      addFinger(){
        this.form.finger.push('');
      },
      //删除指纹
      delFinger(index){
        this.form.finger.splice(index,1);
      },
      //人脸图片文件列表移除文件时的钩子
      handleRemove(file, fileList) {
        // console.log(file, fileList);
      },
      //人脸图片点击文件列表时的钩子
      handlePictureCardPreview(file) {
        this.form2.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      //tab点击
      handleClick(tab, event) {
        // console.log(tab, event);
      },
      //获取临时用户列表
      async getUserList(curr,limits){
        let that = this
        that.tableLoading=true
        let dataObj={
          'perPage': limits ? limits : that.page,//每页显示多少条数据
          'page': curr ? curr : that.curr,//当前页
          'phone_no': that.keyword.phone_no,//手机号
          'user_name': that.keyword.user_name,//姓名
        }
        let res = await userApi.getTemporaryList(dataObj)
        if (res.meta.code === 200) {
          that.casualData = res.data.list
          that.pageCount = parseInt(res.data.pageCount)
          that.tableLoading=false
        } else {
          that.tableLoading=false
          showToast(res.meta.message)
        }
      },
      //分页
      CurrentChange(val) {
        this.curr = val
        // console.log(`当前页: ${val}`);
        this.getUserList(val)
      },
      CurrentSizeChange(val) {
        this.page = val
        // console.log(`当前页: ${val}`);
        this.getUserList()

      },
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      }
    }
  }
</script>

<style lang="scss">
// .mainBodyContent{
//   height: calc(100vh - 194px);
//   overflow-y:auto; 
// }
.CCasualUser{
  .searchDiv{
    .el-input,.el-button{
      display: block;
    }
  }
  .mr10{
    margin-right: 10px;
  }
  .mt20{
    margin-top:20px;
  }
  .flex{
    display:flex;
    align-items:center;
  }
  .fs25{
    font-size:25px;
  }
  .biosDio{
    .el-dialog__body{
      padding:10px 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CUserManege/CCasualUser.vue